import produce, { Draft } from 'immer';

import {
    DataLoadedAction,
    ErrorLoadingDataAction,
    LoadingDataAction,
    SetTimeAction,
    TemplateLoadedAction,
    TypeKeys,
} from '../../state-management/widgetblock/actions/types';
import { Data } from '../types';
import { HarbourDialConfigBlockState, HarbourDialState } from './types';
import mergeTemplateAndData, { RequiredHarbourDialState } from './utils/mergeTemplateAndData';

type Actions = LoadingDataAction | TemplateLoadedAction<HarbourDialConfigBlockState> | ErrorLoadingDataAction | SetTimeAction | DataLoadedAction<Data[]>;

const INITIAL_STATE: HarbourDialState = {
    viewblockState: null,
    currentTime: null,
    datasets: null,
};

const checkIfEverythingLoaded = ({ datasets, viewblockState, currentTime }: HarbourDialState) => Boolean(datasets && viewblockState && currentTime);

const reducer = produce((draft, action: Actions) => {
    switch (action.type) {
        case TypeKeys.LOADING_DATA:
            draft.isLoadingData = true;

            break;

        case TypeKeys.ERROR_LOADING_DATA:
            draft.isLoadingData = false;

            break;

        case TypeKeys.SET_TIME:
            draft.currentTime = action.payload;

            break;

        case TypeKeys.TEMPLATE_LOADED:
            draft.viewblockState = action.payload.data;

            break;

        case TypeKeys.DATA_LOADED:
            draft.datasets = action.payload.data;
            draft.isLoadingData = false;

            break;
    }

    if (checkIfEverythingLoaded(draft)) {
        draft.model = mergeTemplateAndData(draft as Draft<RequiredHarbourDialState>);
    }
}, INITIAL_STATE);

export default reducer;
